import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { pairwise, startWith } from "rxjs/operators";
import { MessageService } from './../../../services/message-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'mobile-text-field',
  templateUrl: './mobile-text-field.component.html',
  styleUrls: ['./mobile-text-field.component.scss']
})
export class MobileTextFieldComponent implements OnInit, OnDestroy {

  @Input() filterInfo = null;
  @Output() dataSelected: EventEmitter<any> = new EventEmitter();
  @Input() optionSelected = "";
  filterForm: FormGroup;
  private unsubscribe: Subject<void> = new Subject();

  constructor(private fb: FormBuilder, private message: MessageService) { }

  valueChanged(event) {
    this.filterInfo['value'] = this.optionSelected;
    this.dataSelected.emit(this.filterInfo);
  }

  ngOnInit() {
      this.message.getMessage().pipe(takeUntil(this.unsubscribe)).subscribe( message => {
        if (message && message.filterReset) {
          this.filterInfo['value'] = "";
        }
      });
  }

  ngOnDestroy(){
    this.filterInfo = null;
    this.optionSelected  = null;
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
